/**
 * Quick-link deep links: seed a view's filter from the URL query string.
 *
 * Query-photos cards link to the tagging/QC pages with the photo's identifiers
 * in the URL (?respId= / ?rgid= / ?questionId= / ?showQCed=1). No view read
 * $route.query before this, so the param → filter-key mapping lives here once
 * rather than in nine views. The target keys are the filter-side vocabulary
 * from capabilities.js CRITERIA, so every surface serialiser already sends
 * them — the backend side needs nothing.
 *
 * Returns a partial filter object for the view to spread over its own filter
 * (`{...this.photoFilter, ...routeFilterSeed(this.$route)}`). Spreading into a
 * fresh object keeps Vue 2 reactivity: assigning a key the data object never
 * declared would render stale in the Applied Filters chips.
 */
export function routeFilterSeed(route) {
  const query = (route && route.query) || {}
  const seed = {}

  if (query.respId) seed.respIdSearchFreeForm = String(query.respId)
  if (query.rgid) seed.rgidSearchFreeForm = String(query.rgid)

  // question_id is an integer column; a non-numeric param wouldn't error,
  // it would silently match nothing — so drop it instead.
  if (query.questionId && !Number.isNaN(Number(query.questionId))) {
    seed.question_id = Number(query.questionId)
  }

  // Group QC pins reviewed=False unless showQCed, so a link to an
  // already-reviewed group must widen the queue or it lands on an empty
  // page. (Photo QC lifts its pins on a respId search by itself.)
  if (query.showQCed) seed.showQCed = true

  return seed
}
